import React from 'react';
import { FunctionComponent } from 'react';
import { createGlobalStyle, css } from 'styled-components';

const Css = createGlobalStyle`
  :root, :host {
    all: unset;

    --page-margin: 5rem;
    --page-max-width: 90rem;
    --side-margin: calc((100vw - min(calc(100vw - var(--page-margin) * 2), var(--page-max-width))) / 2);
    --inside-margin: 2rem;
    @media (max-width: 75rem){
      --page-margin: 3rem;
    }
    @media (max-width: 60rem){
      --page-margin: 2rem;
      --inside-margin: 1rem;
    }
  }
  a {
    color: inherit;
    text-decoration: inherit;
  }
  sup:is(sup) {
    font-size: 0.5em;
    vertical-align: super;
    white-space: nowrap;
  }
`

export const shadowOuterStyle = css`
  all: unset;
  line-height: 1;
  font-family: var(--main-font-family);
  font-weight: 300;
  letter-spacing: 0;
`

export const RootCss: FunctionComponent = () => {
  return <>
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css" />
    <Css />
  </>
}